import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./PatientLabsUIHelpers";

const PatientLabsUIContext = createContext();

export function usePatientLabsUIContext() {
  return useContext(PatientLabsUIContext);
}

export const PatientLabsUIConsumer = PatientLabsUIContext.Consumer;

export function PatientLabsUIProvider({ PatientLabsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openDetailPatientAppointmentPage:
      PatientLabsUIEvents.openDetailPatientAppointmentPage,
  };

  return (
    <PatientLabsUIContext.Provider value={value}>
      {children}
    </PatientLabsUIContext.Provider>
  );
}
